import React from 'react';
interface FieldProps {
  label: string;
  required?: boolean;
  error?: string;
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
}
export function Field({
  label,
  required,
  error,
  htmlFor,
  children,
  className = ''
}: FieldProps) {
  return <div className={className} data-id="element-321" data-mp="3vb0yzedv4au9">
      <label htmlFor={htmlFor} className="block text-[12px] text-ink-500" data-id="element-322" data-mp="42n56qgbf2ui">
        {label}
        {required && <span className="text-red-500" data-id="element-323" data-mp="929hmxobkf29"> *</span>}
      </label>
      <div className="mt-1.5" data-id="element-324" data-mp="8zn84shvbphe">{children}</div>
      {error && <p className="mt-1 text-[12px] font-medium text-red-600" data-id="element-325" data-mp="d1qmppzu3a6w">{error}</p>}
    </div>;
}
export function TextInput({
  id,
  value,
  onChange,
  placeholder,
  error,
  type = 'text'
}: {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: boolean;
  type?: string;
}) {
  return <input id={id} type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} className={`h-9 w-full rounded-lg border bg-white px-3 text-[13px] text-ink-800 placeholder:text-ink-400 focus:outline-none ${error ? 'border-red-400' : 'border-ink-200 focus:border-brand-500'}`} data-id="element-326" data-mp="rq4qc352r2oi" />;
}
export function NativeSelect({
  id,
  value,
  onChange,
  options,
  placeholder,
  error
}: {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  options: string[];
  placeholder: string;
  error?: boolean;
}) {
  return <select id={id} value={value} onChange={e => onChange(e.target.value)} className={`h-9 w-full rounded border bg-white px-2.5 text-[13px] focus:outline-none focus:ring-1 ${value ? 'text-ink-800' : 'text-ink-400'} ${error ? 'border-red-400 focus:border-red-500 focus:ring-red-400' : 'border-ink-300 focus:border-brand-500 focus:ring-brand-500'}`} data-id="element-327" data-mp="1c345babbf7tf">
      <option value="" data-id="element-328" data-mp="1v0x01pbscbfq">{placeholder}</option>
      {options.map(option => <option key={option} value={option} data-id="element-329" data-mp="3p9amcay48vth">
          {option}
        </option>)}
    </select>;
}